/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tld: NonNullable<unknown> }} Tld_Pricing_Registry_LabelInputs */

const id_tld_pricing_registry_label = /** @type {(inputs: Tld_Pricing_Registry_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Registrasi otomatis ${i?.tld}`)
};

const en_tld_pricing_registry_label = /** @type {(inputs: Tld_Pricing_Registry_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Auto registration for ${i?.tld}`)
};

/**
* | output |
* | --- |
* | "Auto registration for {tld}" |
*
* @param {Tld_Pricing_Registry_LabelInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_registry_label = /** @type {((inputs: Tld_Pricing_Registry_LabelInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Registry_LabelInputs, { locale?: "id" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_registry_label(inputs)
	return id_tld_pricing_registry_label(inputs)
});